<div *ngIf="isPanelOpened" class="pending-messages">
  <div class="pending-messages-header alert-warning">
    {{ getPendingMessagesLabel() | translate: { pendingMessagesCount: pendingMessages.length } }}
    <a class="toggle-message-details" (click)="onToggleDetailsClick()">
      <span>{{ getToggleDetailsLabel() | translate }}</span>
    </a>
  </div>

  <div *ngIf="areMessagesShown" class="pending-messages-container">
    <div *ngFor="let message of pendingMessages; let i = index" class="pending-message-container">
      <button type="button" (click)="onDeleteMessageFromQueueClick(i)">
        <svg-icon icon="x"></svg-icon>
        <ng2-tooltip direction="top" text="{{ 'pendingMessages.revokeMessage' | translate }}"></ng2-tooltip>
      </button>
      <div [innerHTML]="message.Text" class="pending-message"></div>
    </div>
  </div>
</div>
